import { createAction, props } from '@ngrx/store';
export const setImmigrationDetails = createAction('[CurrentImmigrationDetails] Set ImmigrationDetails', props<{ immigrationDetails: any }>());
export const clearImmigrationDetails = createAction('[CurrentImmigrationDetails] Clear ImmigrationDetails');